import { FC } from "react";
import { Text, View, StyleSheet } from "@react-pdf/renderer";

export enum AvatarVariant {
  PURPLE = "purple",
  GREEN = "green",
}

type Props = {
  title: string;
  variant?: AvatarVariant;
};

const styles = StyleSheet.create({
  avatar: {
    width: 32,
    height: 32,
    flexBasis: 32,
    borderRadius: 100,
    display: "flex",
    flexDirection: "row",
    justifyContent: "center",
    alignItems: "center",
  },
  variantPurple: {
    backgroundColor: "#F4F1FE",
    color: "#8F6FF6",
    border: "1px solid #8F6FF6",
  },
  variantGreen: {
    backgroundColor: "#EDF7F3",
    color: "#489D78",
    border: "1px solid #489D78",
  },
  char: {
    fontFamily: "SourceSerifPro",
    fontStyle: "normal",
    fontWeight: 400,
    fontSize: 18,
    lineHeight: 1.2,
    textTransform: "uppercase",
  },
});

export const Avatar: FC<Props> & { variant: typeof AvatarVariant } = ({
  title,
  variant = AvatarVariant.PURPLE,
}) => {
  return (
    <View
      style={{
        ...styles.avatar,
        ...(variant === AvatarVariant.PURPLE
          ? styles.variantPurple
          : styles.variantGreen),
      }}
    >
      <Text style={styles.char}>{title.charAt(0)}</Text>
    </View>
  );
};

Avatar.variant = AvatarVariant;
